// deps
import React from "react";

// internal deps
import { IInAppUpiPaymentGroup, InAppUpiGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePaymentActions } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePaymentActions";

interface InAppUpiGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: IInAppUpiPaymentGroup["paymentData"];
}

export function InAppUpiGroupHandler(props: InAppUpiGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const paymentActions = usePaymentActions(props);

    return <InAppUpiGroup paymentActions={paymentActions} paymentData={props.paymentGroup} {...otherProps} />;
}
